import { combineReducers } from '@ynap/reducer-utils';
import * as reducers from './reducers';

const cartReducer = combineReducers(reducers);

export default cartReducer;
